// extracted by mini-css-extract-plugin
module.exports = {"CandidateEditorVideo":"_261hB9zR","EditorIntro":"_1XqoDTgx","titleBlock":"_2HpqFnMt","title":"_1yM5BowQ","titleContainer":"_2sYyzBtD","mainBlock":"_3oGHhx3o","instructionsBlock":"wpPDmmPA","delete":"_2hBiRxMk","modal":"_2xNL3INg","modalContent":"_188SHYJ_","modalButtons":"_1nBE-PQu","instructionsHead":"hRNxpKKh","emptyVideo":"_3F9FBjWZ","saveContent":"_32MW3xHX","profileLocked":"_3AIvmxy-"};
    if(module.hot) {
      // 1746735766183
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  